import { takeLatest, call, put, all } from 'redux-saga/effects';
import { ApiResponse, getApiECpf } from 'services/externalApis';
import { GetCredentialsRequest, Types } from './types';
import { getCredentialsSuccess, getCredentialsFailure } from './actions';

function* getCredentialsRequest(request: {
	type: string;
	payload: GetCredentialsRequest;
}) {
	const data = {
		token: request.payload.token,
		api: request.payload.api,
		apiToken: request.payload.apiToken,
	};
	const response: ApiResponse = yield call(
		getApiECpf,
		`https://login-identific.certificadodigital.com.br/login?token=${data.token}&appId=${data.api}`,
		data.apiToken,
	);

	if (
		response.status === 200 ||
		response.status === 201 ||
		response.status === 302
	) {
		yield put(getCredentialsSuccess(response));
	} else if (response.error) {
		yield put(getCredentialsFailure(response.message));
	}
}

export default all([
	takeLatest(Types.GET_CREDENTIALS_REQUEST, getCredentialsRequest),
]);
